/* eslint-disable no-unused-vars */
const constants = require('../../constants');
const quickviewSlider = require('../../components/slider');
const utils = require('../../utils');

function isMobileDevice() {
    return window.outerWidth < constants.viewport_bootstrap.lg && window.innerWidth < constants.viewport_bootstrap.lg && document.documentElement.clientWidth < constants.viewport_bootstrap.lg && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const slickForReviews = () => {
    if ($('.reviews-products-items').length) {
        quickviewSlider.methods.useCustomizableSlick('.reviews-products-items', false, '', '', 1, { vertical: true });
    }
};

const updateGalleryImgSrc = (htmlElement) => {
    $(htmlElement).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        const carouselImages = $(htmlElement).find('.slick-slide img');
        carouselImages.each((_index, image) => {
            const dataSrc = $(image).attr('data-src');
            const updateImageSrc = (!$(image)[0].hasAttribute('src') || $(image).attr('src') === '') && dataSrc !== '';
            if (updateImageSrc) {
                $(image).attr('src', dataSrc);
            }
        });
    });
};

const customListGallery = () => {
    let carousel = $('#product-gallery');
    const carouselSlick = carousel.hasClass('carousel-inner');

    if (carouselSlick || (window.outerWidth < constants.viewport_bootstrap.lg && $('.primary-images .carousel-inner').length <= 0 && !carousel.hasClass('carousel-mobile-disabled'))) {
        carousel = $('.primary-images .gallery-slider');
        if (isMobileDevice()) {
            quickviewSlider.methods.useCustomizableSlick('.primary-images .gallery-slider', false, '', '', 1, {});
            updateGalleryImgSrc('.primary-images .gallery-slider');
        } else if (carousel.hasClass('slick-initialized')) {
            carousel.slick('destroy');
        }

        $(window).on('resize', () => {
            if (isMobileDevice()) {
                if (carousel.hasClass('slick-initialized')) {
                    carousel.slick('refresh');
                } else {
                    quickviewSlider.methods.useCustomizableSlick('.primary-images .gallery-slider', false, '', '', 1, {});
                    updateGalleryImgSrc('.primary-images .gallery-slider');
                }
            } else if (carousel.hasClass('slick-initialized') && $('.primary-images .carousel-inner').length <= 0) {
                carousel.slick('destroy');
            }
        });

        $(window).bind('orientationchange', () => {
            // eslint-disable-next-line no-restricted-globals
            window.location.reload();
        });
    }
};

const pdpGallerySliders = () => {
    const { prev, next } = utils.getSliderLabels();
    quickviewSlider.methods.useCustomizableSlick('.primary-images .carousel-inner:not(".carousel-set")',
        true,
        `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
        `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`, 1, {
            dots: true,
            responsive: [
                {
                    breakpoint: constants.viewport_bootstrap.lg,
                    settings: {
                        arrows: false,
                    },
                },
            ],
            asNavFor: '.product-gallery-thumb',
        });

    if ($('.carousel-set').length) {
        quickviewSlider.methods.useCustomizableSlick('.primary-images .carousel-set',
            true,
            `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
            `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`, 1, {
                dots: true,
                responsive: [
                    {
                        breakpoint: constants.viewport_bootstrap.lg,
                        settings: {
                            arrows: false,
                        },
                    },
                ],
            });
    }
};

module.exports = {
    slickForReviews: slickForReviews(),
    customListGallery: customListGallery(),
    useCustomizableSlick: pdpGallerySliders(),
};
